<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...While Fetching Data</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Ticket Category

        <div>
            <button mat-raised-button color="primary" style="font-size: 14px;margin-right:
                15px;" (click)="AddTicket()"><mat-icon>add</mat-icon>Add</button>
        </div>

    </div>
</div>

<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- Position Column -->
            <ng-container matColumnDef="srNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> SrNo. </th>
                <td mat-cell *matCellDef="let element"> {{element.srNo}} </td>
            </ng-container>

            <ng-container matColumnDef="category_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Category ID </th>
                <td mat-cell *matCellDef="let element"> {{element.category_id}} </td>
            </ng-container>

            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Category </th>
                <td mat-cell *matCellDef="let element"> {{element.category | titlecase}} </td>
            </ng-container>
            <ng-container matColumnDef="total_amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Price </th>
                <td mat-cell *matCellDef="let element"> {{element.total_amount | titlecase}} </td>
            </ng-container>
            <ng-container matColumnDef="color">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Color </th>
                <td mat-cell *matCellDef="let element"> {{element.color | titlecase}} </td>
            </ng-container>
            <ng-container matColumnDef="auto_assign">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Auto Assign </th>
                <td mat-cell *matCellDef="let element"> {{element.auto_assign | titlecase}} </td>
            </ng-container>
            <ng-container matColumnDef="total_category_tickets">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Total Tickets </th>
                <td mat-cell *matCellDef="let element"> {{element.total_category_tickets | titlecase}} </td>
            </ng-container>
            <ng-container matColumnDef="max_allowed">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Max Allowed </th>
                <td mat-cell *matCellDef="let element"> {{element.max_allowed | titlecase}} </td>
            </ng-container>

            <ng-container matColumnDef="is_active">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Is Active? </th>
                <td mat-cell *matCellDef="let element"> <mat-checkbox [(ngModel)]="element.is_active"
                        (change)="onCheckboxChange($event, element)">
                    </mat-checkbox></td>
            </ng-container>

            <!-- <ng-container matColumnDef="allowed_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created By</th>
                <td mat-cell *matCellDef="let element"> {{element.allowed_count}} </td>
            </ng-container>

            <ng-container matColumnDef="total_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Updated By </th>
                <td mat-cell *matCellDef="let element"> {{element.total_count}} </td>
            </ng-container> -->

            <ng-container matColumnDef="action" stickyEnd justify="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-raised-button color="primary" matTooltip="Edit" style="margin-left: 5px;"
                        (click)="EditTicketCategory(element.category_id)">
                        <mat-icon class=" m-0">edit</mat-icon>
                    </button>
                    <button mat-raised-button color="warn" matTooltip="Delete" style="margin-left: 5px;"
                        (click)="DeleteTicket(element.category_id)">
                        <mat-icon class=" m-0">delete</mat-icon>
                    </button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Select page of periodic elements">
    </mat-paginator>
</div>